import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBlock: 40,
    paddingInline: theme.palette.custom.lgPaddingInline,
    [theme.breakpoints.up('1700')]: {
      paddingInline: theme.palette.custom.xlPaddingInline,
    },
    [theme.breakpoints.down('md')]: {
      paddingInline: theme.palette.custom.smPaddingInline,
    },
  },
  breadcrumbs: {
    '& .MuiTypography-root': {
      [theme.breakpoints.down('sm')]: {
        fontSize: 13,
      },
    },
  },
  storyWrapper: {
    display: 'flex',
    rowGap: 12,
    paddingBlock: 20,
    maxWidth: '100%',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
    },
  },
  storeImg: {
    width: 632,
    height: 380,
    objectFit: 'cover',
    [theme.breakpoints.down('lg')]: {
      width: 480,
      height: 320,
      objectFit: 'fill',
    },
    [theme.breakpoints.down('md')]: {
      width: 380,
      height: 280,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: 280,
    },
    [theme.breakpoints.down('400')]: {
      width: '100%',
      height: 200,
    },
  },
  storyContent: {
    paddingInlineStart: 20,
    [theme.breakpoints.down('sm')]: {
      paddingInlineStart: 0,
    },
  },
  title: {
    '& .MuiTypography-root': {
      fontWeight: 600,
      color: theme.palette.custom.main,
      paddingBlockEnd: 8,
      [theme.breakpoints.down('sm')]: {
        fontSize: 24,
      },
    },
  },
  description: {
    '& .MuiTypography-root': {
      textOverflow: 'ellipsis',
    },
  },
  countsWrapper: {
    background: '#F5F7FF',
    marginBlock: 40,
    paddingBlock: 40,
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    rowGap: 16,
    paddingInline: theme.palette.custom.lgPaddingInline,
    [theme.breakpoints.up('1700')]: {
      paddingInline: theme.palette.custom.xlPaddingInline,
    },
    [theme.breakpoints.down('md')]: {
      paddingInline: theme.palette.custom.smPaddingInline,
    },
  },
  countTitle: {
    '& .MuiTypography-root': {
      textAlign: 'center',
      fontSize: 18,
      lineHeight: 1.7,
      [theme.breakpoints.down('md')]: {
        fontSize: 16,
      },
    },
  },
  count: {
    '& .MuiTypography-root': {
      textAlign: 'center',
      paddingBlockStart: 8,
      fontWeight: 600,
    },
  },
}))

export default useStyles
